import client from "services/ngage/api-client";
import DataResource from "types/DataResource";
import {parameters} from "../string";
import {Floor, FloorData} from "../../types/Floor";
import deserializeFloor from "./deserializers/floor";

type FloorFilters = {
    page?: number
    perPage?: number
    building?: number
}

/**
 * Get all floors (paginated)
 */
const filtered = async (filters: FloorFilters = {}) => {
    const params = parameters(filters, {page: 1, per_page: 100});

    try {
        const page = (await client.get<DataResource<Floor> | null>('/floors', {params})).data

        if (page) page.data = page.data.map(deserializeFloor)

        return page
    } catch (error) {
        console.error("Unable to fetch floors", error)
        return null
    }
}

/**
 * Get a single floor
 *
 * @param {number} floorId
 */
const get = async (floorId: number) => {
    try {
        const floor = (await client.get<Floor | null>(`/floors/${floorId}`)).data
        return floor ? deserializeFloor(floor) : null
    } catch (error) {
        console.error(`Unable to fetch floor ${floorId}`, error)
        return null
    }
}

/**
 * Store a new floor
 *
 * @param data
 */
const store = async (data: FloorData) => {
    try {
        const floor = (await client.post<Floor | null>('/floors', data)).data
        return floor ? deserializeFloor(floor) : null
    } catch (error) {
        console.error("Unable to store floor", error)
        throw error
    }
}

/**
 * Update an existing floor
 *
 * @param {number} floorId
 * @param data
 */
const update = async (floorId: number, data: FloorData) => {
    try {
        const floor = (await client.put<Floor | null>(`/floors/${floorId}`, data)).data
        return floor ? deserializeFloor(floor) : null
    } catch (error) {
        console.error(`Unable to update floor ${floorId}`, error)
        throw error
    }
}

/**
 * Permanently delete a floor
 *
 * @param {number} floorId
 */
const destroy = async (floorId: number) => {
    try {
        return (await client.delete<null>(`/floors/${floorId}`)).status === 204
    } catch (error) {
        console.error(`Unable to delete floor ${floorId}`, error)
        throw error
    }
}

const floors = {
    filtered,
    get,
    store,
    update,
    destroy
}

export default floors;